export default "__VITE_ASSET__CyLh8Jjt__"